import { MSelect } from "components/forms";
import { adminService, dateHelper, segreteriaIULService } from "libs";
import { Container } from "design-react-kit";

import React, { Component } from "react";
import { MTable } from "components/table";

export class IULLessonOnSiteSchedule extends Component {
  state = {
    loading: false,
    currentCourseType: "",
    currentCourseId: "",
    currentAA: "",
    courses: [],
    payloadCourses: {
      options: [{ label: "Selezionare un corso", value: "" }],
    },
    isSearched: false,
    rndKey: 0,
    lessons: [],
    error: null,
  };

  payloadCourseTypes = {
    options: [
      { label: "Selezionare un tipo di corso", value: "" },
      { label: "Corsi Abilitanti 30CFU All2", value: "ABILITAZIONI30CFU" },
      { label: "Corsi Abilitanti 60CFU All1", value: "ABILITAZIONI60CFU" },
      { label: "Corsi 30CFU All2", value: "CORSI30ALL2" },
      { label: "Corsi 36CFU All5", value: "CORSI36ALL5" },
      { label: "Corsi 30CFU Ex art.13", value: "IUL30CFU" },
    ],
  };

  payloadAA = {
    options: [
      { label: "Selezionare un anno accademico", value: "" },
      { label: "2024/2025", value: "2024" },
      { label: "2025/2026", value: "2025" },
    ],
  };

  onChangeAA = (id, value) => {
    this.setState({
      currentAA: value,
      currentCourseType: "",
      currentCourseId: "",
      isSearched: false,
      lessons: [],
      payloadCourses: {
        options: [{ label: "Selezionare un corso", value: "" }],
      },
    });
  };

  onChangeCourseType = (id, value) => {
    this.setState({
      currentCourseType: value,
      currentCourseId: "",
      lessons: [],
      payloadCourses: {
        options: [{ label: "Selezionare un corso", value: "" }],
      },
      isSearched: false,
      rndKey: Math.floor(Math.random() * 1000 + 1),
    });

    if (this.state.currentAA && value) {
      this.loadRemoteCourse(value, this.state.currentAA);
    }
  };

  onChangeCourse = (id, value) => {
    this.setState({ currentCourseId: value });

    const classId = 30;
    this.loadRemoteLessons(value, classId);
  };

  loadRemoteCourse = (currentCourseType, currentAA) => {
    this.setState({ loading: true });

    const filter = {
      searchFilter: {
        instituteCompany: "iul",
        courseType: currentCourseType,
        aa: currentAA,
      },
    };

    adminService
      .course(filter)
      .then(({ data }) => {
        const { courses, distinctAA } = data.payload;

        const courseOptions = courses.map((course) => ({
          label: course.code,
          value: course.id,
        }));

        this.setState({
          courses,
          distinctAA,
          payloadCourses: {
            options: [
              { label: "Selezionare un corso", value: "" },
              ...courseOptions,
            ],
          },
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  };

  loadRemoteLessons = (courseId, classId) => {
    this.setState({ loading: true });

    segreteriaIULService
      .loadLessonOnSiteSchedule(courseId, classId)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(
          data.payload.lessonOnSiteSchedule.lessonOnSiteSchedules
        ).forEach(([key, val]) => {
          items.push(val);
        });
        //--- end: prepare reactTable ---

        this.setState({
          loading: false,
          lessons: items,
          isSearched: true,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  };

  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "title",
        Header: "Titolo",
        accessor: "title", // accessor is the "key" in the data
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDateUTC(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
      {
        id: "teacher",
        Header: "Docente",
        accessor: "teacher",
      },
      {
        id: "ssd",
        Header: "Materia",
        accessor: "ssd",
      },
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: "competitionClass",
      },
    ],
    actions: [],
  };

  render() {
    const { payloadCourses, lessons, rndKey, isSearched } = this.state;

    return (
      <div className="container">
        <h1>Calendario Lezioni in Presenza</h1>

        <MSelect
          onChange={this.onChangeAA}
          id="sAA"
          name="sAA"
          payload={this.payloadAA}
        />

        <MSelect
          onChange={this.onChangeCourseType}
          id="sCourseType"
          name="sCourseType"
          payload={this.payloadCourseTypes}
        ></MSelect>

        <MSelect
          onChange={this.onChangeCourse}
          id="sCourse"
          name="sCourse"
          payload={payloadCourses}
        ></MSelect>

        {isSearched && (
          <Container>
            <MTable
              key={rndKey}
              tableData={lessons}
              tableConfig={this.tableConfig}
            />
          </Container>
        )}
      </div>
    );
  }
}
